<template>
  <div class="RecentWork">
    <div id="recentWork" class="flex flex-col mt-20 pt-24 pb-40 items-center text-center tracking-wider wow fadeInUp" data-wow-delay=".3s">
      <span class="w-full text-3xl font-bold text-mytext-primary">{{ $t('recentWork.title') }}</span>
      <span class="px-10 p-2 text-center text-gray-100 text-mytext-primary">
        <span class="text-sm">{{ $t('recentWork.details') }}</span>
        <span><a href="#" class="font-bold"> Github</a></span>
      </span>
      <div class="w-full flex flex-wrap justify-center px-10 mt-5">
        <div class="container relative w-full md:w-1/2 lg:w-1/3 mt-6 overflow-hidden wow fadeInUp animated" data-wow-delay=".3s" v-for="(item,index) in recentwork " :key="index">
          <div class="relative bg-background-primaryDark transition-1 shadow-xl mx-3 px-10 py-12 rounded flex flex-col border-2 border-bdprimary items-center text-center ">
            <span class="w-24 h-24"><img :src="item.imgPath" alt="musab"></span>
            <span class="font-bold text-lg text-mytext-primary mt-2 tracking-wider" v-text="item.name" />
            <!-- </div> -->
            <div class="overlay absolute inset-0 h-full w-full opacity-0 transition-1 bg-gradient rounded flex flex-col items-center justify-center text-center">
              <span class="text-white font-thin text-sm px-5 mt-2 tracking-wider" v-text="item.hoverText" />
              <a :href="item.visitUrl" :class="item.disabledUrl ? 'disabled':''" class="mt-4 px-6 py-2 rounded bg-white text-gray-800 tracking-wider text-sm font-bold" v-text="item.btnText"/>
            </div>
          </div>
        </div>
      </div>

      <a href="https://github.com/m-HARD" class="bg-gradient text-white mt-16 px-8 py-2 rounded tracking-wider text-lg flex flex-wrap items-center wow fadeInUp" data-wow-delay=".3s">
        <span><i class="fa fa-lg fa-github"></i></span>
        <span class="mx-1"></span>
        <span>{{ $t('recentWork.more') }}</span>
      </a>
    </div>

  </div>
</template>

<script>
export default {
  name: 'RecentWork',
  components: {},
  data() {
    return {
        recentwork:[
            {
                name:"Simple Games",
                imgPath:require("@/assets/img/avatar.99ed4258.svg"),
                hoverText:this.$i18n.t('recentWork.recentwork.simpleGames.hoverText'),
                disabledUrl:false,
                btnText:this.$i18n.t('recentWork.recentwork.simpleGames.btnText'),
                visitUrl:"http://m-hard.me/SimpleGames/"
            },
            {
                name:"Tailwind Forms Builder",
                imgPath:require("@/assets/img/avatar.99ed4258.svg"),
                hoverText:this.$i18n.t('recentWork.recentwork.tailwindFormsBuilder.hoverText'),
                disabledUrl:false,
                btnText:this.$i18n.t('recentWork.recentwork.tailwindFormsBuilder.btnText'),
                visitUrl:"http://m-hard.me/Tailwind-Forms-Builder/"
            },
            {
                name:"Tailwind Component",
                imgPath:require("@/assets/img/avatar.99ed4258.svg"),
                hoverText:this.$i18n.t('recentWork.recentwork.tailwindComponent.hoverText'),
                disabledUrl:false,
                btnText:this.$i18n.t('recentWork.recentwork.tailwindComponent.btnText'),
                visitUrl:"http://m-hard.me/Tailwind-Component/"
            },
            {
                name:"Wakura Alawghad",
                imgPath:require("@/assets/img/avatar.99ed4258.svg"),
                hoverText:this.$i18n.t('recentWork.recentwork.wakuraAlawghad.hoverText'),
                disabledUrl:false,
                btnText:this.$i18n.t('recentWork.recentwork.wakuraAlawghad.btnText'),
                visitUrl:"http://m-hard.me/wakura_alawghad/"
            },
            {
                name:"NooN School",
                imgPath:require("@/assets/img/avatar.99ed4258.svg"),
                hoverText:this.$i18n.t('recentWork.recentwork.noonSchool.hoverText'),
                disabledUrl:true,
                btnText:this.$i18n.t('recentWork.recentwork.noonSchool.btnText'),
                visitUrl:""
            },
            {
                name:"Marketing WebSite",
                imgPath:require("@/assets/img/avatar.99ed4258.svg"),
                hoverText:this.$i18n.t('recentWork.recentwork.marketingWebSite.hoverText'),
                disabledUrl:false,
                btnText:this.$i18n.t('recentWork.recentwork.marketingWebSite.btnText'),
                visitUrl:"https://github.com/m-HARD/MarketingWebSite"
            },
            {
                name:"Githup View",
                imgPath:require("@/assets/img/avatar.99ed4258.svg"),
                hoverText:this.$i18n.t('recentWork.recentwork.githupView.hoverText'),
                disabledUrl:false,
                btnText:this.$i18n.t('recentWork.recentwork.githupView.btnText'),
                visitUrl:"https://github.com/m-HARD/gitView"
            },
            {
                name:"Forum",
                imgPath:require("@/assets/img/avatar.99ed4258.svg"),
                hoverText:this.$i18n.t('recentWork.recentwork.forum.hoverText'),
                disabledUrl:false,
                btnText:this.$i18n.t('recentWork.recentwork.forum.btnText'),
                visitUrl:"https://github.com/m-HARD/Forum"
            }
        ],
    }
  },
  computed: {
    langLocaleNow(){
      return this.$i18n.locale
    }
  },
  watch: {
    langLocaleNow(){
      Object.assign(this.$data,this.$options.data.call(this))
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .container:hover .overlay {
    opacity: 0.92;
  }
  a.disabled {
    pointer-events: none;
    cursor: default;
  }
</style>